/**
 * @file useLabelJobHide.ts
 * @description «Скрыть файл» записи журнала печати этикеток (phase19.22 шаг 5,
 *   решение пользователя 2026-09-26): `POST admin/wms/labels/jobs/:id/hide`.
 *
 * Общий для журнала приёмки (`useReceiptLabels`) и журнала ячеек
 * (`useBinLabelJobs`). После успеха журнал перечитывается (`reload`), а не
 * правится руками — пометку «файл скрыт» и дату ставит сервер.
 */

import { useCallback, useState } from "react";

import { LABEL_TEXT } from "./label-texts";
import { useNotify } from "../../ui/NotifyProvider";
import { labelsApi, type LabelPrintJobDto } from "../../../lib/api-labels";
import { wmsErrorText } from "../../../lib/wms-error-text";

export function useLabelJobHide(reload: () => void) {
  const notify = useNotify();
  const [hidingId, setHidingId] = useState<string | null>(null);

  /** true — файл скрыт (диалог подтверждения можно закрывать). */
  const hideFile = useCallback(
    async (job: LabelPrintJobDto): Promise<boolean> => {
      setHidingId(job.id);
      try {
        await labelsApi.hideJob(job.id);
        notify.success(LABEL_TEXT.hideFileDone);
        reload();
        return true;
      } catch (err) {
        notify.error(wmsErrorText(err, "Не удалось скрыть файл — повторите позже"));
        return false;
      } finally {
        setHidingId(null);
      }
    },
    [notify, reload],
  );

  return { hidingId, hideFile };
}
